import {FDSPhase, isFDSPass} from '@web/core/constants'
import {FDSStatus} from '@web/slices/fds/slice'
import makeSlice from '@web/slices/fds/sliceMaker'

import {startSubscription} from '../../actions'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(startSubscription.fulfilled, (state, {payload: {orderAuthentication}}) => {
                const {authenticationLevel, fdsUnavailablePaymentType, fdsUuid, sessionKey} = orderAuthentication

                state.uuid = fdsUuid

                const authentication = (() => {
                    if (isFDSPass(authenticationLevel)) {
                        return {
                            level: authenticationLevel,
                            sessionKey,
                            fdsCheckHash: null,
                            sessionCheckHash: null,
                        }
                    } else {
                        return {
                            level: authenticationLevel,
                            blockReason: fdsUnavailablePaymentType,
                            fdsCheckHash: null,
                            sessionCheckHash: null,
                        }
                    }
                })()

                state.authentication = authentication
                state.status = FDSStatus.PENDING
                state.phase = FDSPhase.STARTED
            })
            .addCase(startSubscription.rejected, (state) => {
                state.status = FDSStatus.PENDING
                state.phase = FDSPhase.INACTIVE
            })
    },
})

export default slice.reducer
